import { render, staticRenderFns } from "./info-panel.vue?vue&type=template&id=6fb8e710&scoped=true"
import script from "./info-panel.vue?vue&type=script&lang=js"
export * from "./info-panel.vue?vue&type=script&lang=js"
import style0 from "./info-panel.vue?vue&type=style&index=0&id=6fb8e710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8e710",
  null
  
)

export default component.exports